/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpAdminStatsResponseBoardStats
 */
export interface FuelUpAdminStatsResponseBoardStats {
    /**
     * 
     * @type {number}
     * @memberof FuelUpAdminStatsResponseBoardStats
     */
    activeBoards?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpAdminStatsResponseBoardStats
     */
    totalSpaces?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof FuelUpAdminStatsResponseBoardStats
     */
    mostPopularSpaces?: Array<object>;
}

/**
 * Check if a given object implements the FuelUpAdminStatsResponseBoardStats interface.
 */
export function instanceOfFuelUpAdminStatsResponseBoardStats(value: object): value is FuelUpAdminStatsResponseBoardStats {
    return true;
}

export function FuelUpAdminStatsResponseBoardStatsFromJSON(json: any): FuelUpAdminStatsResponseBoardStats {
    return FuelUpAdminStatsResponseBoardStatsFromJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseBoardStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpAdminStatsResponseBoardStats {
    if (json == null) {
        return json;
    }
    return {
        
        'activeBoards': json['activeBoards'] == null ? undefined : json['activeBoards'],
        'totalSpaces': json['totalSpaces'] == null ? undefined : json['totalSpaces'],
        'mostPopularSpaces': json['mostPopularSpaces'] == null ? undefined : json['mostPopularSpaces'],
    };
}

export function FuelUpAdminStatsResponseBoardStatsToJSON(json: any): FuelUpAdminStatsResponseBoardStats {
    return FuelUpAdminStatsResponseBoardStatsToJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseBoardStatsToJSONTyped(value?: FuelUpAdminStatsResponseBoardStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeBoards': value['activeBoards'],
        'totalSpaces': value['totalSpaces'],
        'mostPopularSpaces': value['mostPopularSpaces'],
    };
}

